import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'

export const buttonOverride = (
  disabled: boolean,
  collapsed: boolean,
  hideButtonText: boolean,
  popoverOpened: boolean
): CSSObject => ({
  ...Typography.T300,
  borderRadius: 6,
  height: Spacing.L,
  justifyContent: 'space-between',
  paddingInlineStart: Spacing.S,
  paddingInline: collapsed ? 5 : 6,
  width: collapsed ? Spacing.L : '100%',
  backgroundColor: Color.light.Surface.N000,
  borderColor: popoverOpened
    ? Color.light.Surface.A200
    : Color.light.Surface.N300,
  '&:hover': {
    borderColor: disabled ? Color.light.Surface.N300 : Color.light.Surface.A200,
  },
  '&:disabled': {
    borderColor: Color.light.Surface.N300,
  },
  '.lapidary-button-icon': {
    margin: hideButtonText ? 'auto' : 0,
  },
})

export const noOutlineStyles: CSSObject = {
  border: 'none',
  height: 14,
  paddingInline: 0,
  paddingInlineStart: 0,
  backgroundColor: 'transparent',
  color: Color.light.Surface.A200,
  '&:hover': {
    '&::before': {
      color: Color.light.Translucent.N12,
    },
  },
}
